import { render, staticRenderFns } from "./ELearningYoutubeCard.vue?vue&type=template&id=2b1fbc17"
import script from "./ELearningYoutubeCard.vue?vue&type=script&lang=js"
export * from "./ELearningYoutubeCard.vue?vue&type=script&lang=js"
import style0 from "./ELearningYoutubeCard.vue?vue&type=style&index=0&id=2b1fbc17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports